import  {get,post,patch}  from '../washtraxClient';

  const getZipData = (data) => {
    return get(`getzipdata/${data}`);
  };
const updateSettings=(data,option)=>{
  return post(`client/upload/logo`,data,option);
}
const uploadImage=(data,option)=>{
  return post('image/upload',data,option)
}
const shareImage=(data)=>{
  return post('mail/equipment/Imagedocs',data)
}
const updateServices=(id,data)=>{
  return patch(`/ticket/update/certificate/services/${id}`,data);
}
const updateCertificateNumber=(id,data)=>{
  return patch(`/ticket/update/certificate/${id}`,data);
}
const preWashToggle=(data)=>{
  return post('client/update-settings',data)
}
const yardReportEmail=(data)=>{
  return post('send/email-attachment',data)
}
const certificateServices=()=>{
  return get('get/certificate/services')
}
export default {
  getZipData,
  updateSettings,
  uploadImage,
  shareImage,
  updateServices,
  updateCertificateNumber,
  preWashToggle,
  yardReportEmail,
  certificateServices,
};